import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage-angular';
import { ApiService } from './api.service';
import { tap } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
	providedIn: 'root'
})
export class UserService {
	currentUser = new BehaviorSubject(null);

	constructor(
		private apiService: ApiService,
		private storage: Storage,
		private http: HttpClient
	) { }

	syncUserActivo() {
		console.log('Sync user');
		return this.apiService.getUserActive().pipe(
			tap(async (response: any) => {
				if (response) {
					this.setUserActivo(response.usuario);
				}
			})
		);
	}

	async getUserActive() {
		const user = await this.storage.get('usuario');
		if (user) {
			this.currentUser.next(user);
			return user;
		}
	}

	/*
	  updateFirebaseToken(token: any) {
		  console.log('About to update firebase');
		  return this.http.post(`${API_SERVER_ADDRESS}/usuarios/updateFirebaseToken.json`, token).pipe(
			  tap(
				  async (response: any) => {
					  console.log('--------------------Firebase token updated', response.user);
					  this.setUserActivo(response.usuario);
				  },
				  err => {
					  console.log('----------------------', err);
				  }
			  )
		  ).subscribe();
	  }
	  */

	setUserActivo(user: any) {
		this.storage.set('usuario', user);
		this.currentUser.next(user);
	}

	delUserActivo() {
		this.storage.remove('usuario');
		this.currentUser.next(null);
	}

	/*
	  updatePassword(user: any) {
		  return this.http.post(`${API_SERVER_ADDRESS}/usuarios/update.json`, user);
	  }
	*/
}